import queryString from 'query-string'
import {FormattedMessage, useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {TransitionGroup} from 'react-transition-group'
import ExternalLink from '../../../assets/icons/ExternalLink.svg'
import Times from '../../../assets/icons/Times.svg'
import Question from '../../../assets/icons/vanshare/Question.svg'
import Search from '../../../assets/icons/vanshare/Search.svg'
import GooglePlayDimension from '../../../assets/imgs/new-vanshare/app/google-play.png?size'
import React, {useCallback, useContext, useState} from 'react'
import AppStore from '../../../assets/icons/AppStore.svg'
import GooglePlay from '../../../assets/imgs/new-vanshare/app/google-play.png'
import {areaMessages} from '../../../config/commonMessages'
import {
  areaInPrefectureList,
  areaList,
  ContactType,
  CURRENT_LOCATION,
  getPrefecture,
  Locale,
  UrlPrefix,
} from '../../../config/constants'
import {dateToQuery, maxCalendarYear, thisYear} from '../../../helpers/dateUtil'
import FadeTransition from '../../common/FadeTransition'
import FaMapMarkerAlt from '../../../assets/icons/FaMapMarkerAlt.svg'
import CheckIn from '../../../assets/icons/vanshare/SignIn.svg'
import CheckOut from '../../../assets/icons/vanshare/SignOut.svg'
import LocaleText from '../../common/LocaleText'
import BackDrop from '../../containers/BackDrop'
import {RouterContext} from '../../containers/Context'
import DateField from '../../fields/custom/DateField'
import AutoFormSave from '../../fields/form/AutoFormSave'
import {useIsSsr, useLocale} from '../../hocs/hooks'
import {ListMode} from '../stations/MapListNavbar'
import {checkAreaOrPrefecture, IHomeForm} from './CoverPC'
import styles from './CoverSM.scss'
import ResponsiveImg from '../../common/ResponsiveImg'
import TopSP0 from '../../../assets/imgs/new-vanshare/TOP_SP_main_10.png'
import TopSP1 from '../../../assets/imgs/new-vanshare/TOP_SP_main_08.jpg'
import TopSP2 from '../../../assets/imgs/new-vanshare/TOP_SP_main_02.jpg'
import TopSP3 from '../../../assets/imgs/new-vanshare/TOP_SP_main_09.jpg'
import TopSP4 from '../../../assets/imgs/new-vanshare/TOP_SP_main_04.jpg'
import TopSP5 from '../../../assets/imgs/new-vanshare/TOP_SP_main_05.jpg'

import { Form, Field } from 'react-final-form'
import Slider from 'react-slick'
import { isNativeWebview } from '../../../helpers/reactNativeWebview'

const CarstaySMSearchDialog = ({ onClose, isStation }: {
  onClose: () => any
  isStation?: boolean
}) => {
  const {history} = useContext(RouterContext)!
  const locale = useLocale()
  const intl = useIntl()

  const onSubmit = (values: IHomeForm) => {
    const {category} = values
    const { area, checkIn, checkOut } = values
    history.push({
      pathname: `/${locale}/${category === ContactType.carstay ? 'stations' : 'car-list'}/${checkAreaOrPrefecture(area)}`,
      search: queryString.stringify({
        mode: ListMode.map,
        checkIn: dateToQuery(checkIn),
        checkOut: dateToQuery(checkOut)
      })
    })
  }
  return <BackDrop onBackgroundClicked={onClose}>
    <div tabIndex={-1} role="dialog" className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <Times className={styles.close} onClick={onClose}/>
          <div className="w-100 text-center">
            <h2 className={['mt-2', styles.dialogTitle].join(' ')}>
              <FormattedMessage id="search.btnLabel"/>
            </h2>
          </div>
        </div>
        <div className="modal-body">
          <div className="pre-wrap">
            <Form onSubmit={onSubmit} initialValues={{...{category: isStation ? ContactType.carstay : ContactType.vanshare }}}>
              {({handleSubmit, values}) => <>
                <AutoFormSave name="sp-home"/>
                <form onSubmit={handleSubmit}
                      id="coverForm">

                  <div className="form-group d-flex flex-md-row flex-column align-items-md-end pt-1 my-0 mx-md-3 mx-2">
                    <div className="d-md-flex flex-md-grow-1 flex-grow-0">

                      <div className={['flex-grow-1', styles.dialogCategory].join(' ')}>
                        <div className={['mb-1'].join(' ')}>
                          <FormattedMessage id="post.categories" />
                        </div>
                        <div className={['position-relative', styles.inputForm].join(' ')}>
                          <Field
                            className="pl-3 custom-select h-100"
                            component="select"
                            name="category">
                            <FormattedMessage id="search.van" defaultMessage="Camper-van">
                              {message => <option value={ContactType.vanshare}>
                                {message}
                              </option>
                              }
                            </FormattedMessage>
                            <FormattedMessage
                              id="search.spotAndActivity"
                              defaultMessage="Spots to stay the car, Activities"
                            >
                              {message => <option value={ContactType.carstay}>
                                {message}
                              </option>
                              }
                            </FormattedMessage>
                          </Field>
                        </div>
                      </div>

                      <div className={['flex-grow-1', styles.dialogLocation].join(' ')}>
                        <div className={['mb-1 font-weight-bold'].join(' ')}>
                          <FaMapMarkerAlt
                            className={[
                              'fa mb-1 mr-1', values.category === ContactType.carstay ? 'text-primary' : 'text-van'
                            ].join(' ')}
                          />
                          <FormattedMessage id="carsSearch.area" />
                        </div>
                        <div className={['position-relative', styles.inputForm].join(' ')}>
                          <Field component="select" {...{ name: 'area' }}
                                className="pl-3 custom-select h-100">
                            <FormattedMessage id="stationsSearch.allCountry">
                              {message => <option value="">
                                {message}
                              </option>
                              }
                            </FormattedMessage>
                            <FormattedMessage id="stationsSearch.currentLocation">
                              {message => <option value={CURRENT_LOCATION}>
                                {message}
                              </option>
                              }
                            </FormattedMessage>
                            {areaList.flatMap(area => {
                              const prefectures = areaInPrefectureList[area].map(
                                prefecture => ({ text: `　${getPrefecture(locale, prefecture)}`, value: prefecture })
                              )
                              return [
                                { text: intl.formatMessage({ ...areaMessages[area] }), value: area }, ...prefectures
                              ]
                            }).map((x, i) => <option key={i} value={x.value}>
                                {x.text}
                              </option>
                            )}
                          </Field>
                        </div>
                      </div>

                      <div className={['row mx-0', styles.dialogTime].join(' ')}>
                        <div className="flex-grow-0 w-50">
                          <div className={['mb-1 font-weight-bold'].join(' ')}>
                            <CheckIn
                              className={[
                                'fa mb-1 mr-1 font-size-18',
                                values.category === ContactType.carstay ? 'text-primary' : 'text-van'
                              ].join(' ')}
                            />
                            {values.category !== ContactType.carstay
                              ? <FormattedMessage id="carsSearch.pickup" />
                              : <FormattedMessage id="stationsSearch.checkIn"/>}
                          </div>
                          <Field
                            component={DateField}
                            name="checkIn"
                            className={['px-2', styles.checkIn].join(' ')}
                            isDisabled={
                              (clientDate: Date) => clientDate.getTime() < new Date(Date.now()).setHours(0, 0, 0, 0)
                            }
                            minYear={thisYear}
                            maxYear={maxCalendarYear}
                          />
                        </div>

                        <div className="flex-grow-0 w-50">
                          <div className={['mb-1 font-weight-bold'].join(' ')}>
                            <CheckOut
                              className={['fa mb-1 mr-1 font-size-18', values.category === ContactType.carstay ? 'text-primary' : 'text-van']
                                .join(' ')}
                            />
                            {values.category === ContactType.carstay
                              ? <FormattedMessage id="stationsSearch.checkOut"/>
                              : <FormattedMessage id="carsSearch.return" />}
                          </div>
                          <Field
                            component={DateField}
                            name="checkOut"
                            className={['px-2', styles.checkOut].join(' ')}
                            alignRight
                            isDisabled={
                              (clientDate: Date) => clientDate.getTime() < new Date(Date.now()).setHours(0, 0, 0, 0)
                            }
                            minYear={thisYear}
                            maxYear={maxCalendarYear}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={['flex-shrink-0', styles.dialogSearchBtn].join(' ')}>
                      <button
                        type="submit"
                        className={
                          ['btn px-4 py-0 font-weight-bold', styles.button, values.category === ContactType.carstay ? 'btn-primary' : 'btn-van']
                            .join(' ')
                        }
                      >
                        <Search className="fa mb-1 mr-1"/>
                        <FormattedMessage id="search.btnLabel"/>
                      </button>
                    </div>
                    <a
                      href="https://persistent-direction-0f1.notion.site/333beeb0fe76453892cbef5f7456a12f"
                      target="_blank"
                      className={
                        ['text-van d-inline-block my-3 pt-1 font-size-12 underline text-right', styles.sectionTitle]
                          .join(' ')
                      }
                    >
                      <Question className="mb-1 mr-1 fa"/>
                      <LocaleText ja="現在地から検索できない場合" en="If you cannot search from your current location"/>
                      <ExternalLink className="fa ml-1 mb-1"/>
                    </a>
                  </div>
                </form>
              </>
              }
            </Form>
          </div>
        </div>
      </div>
    </div>
  </BackDrop>
}

const SearchArea = ({isStation = false}: {isStation?: boolean}) => {
  const [showSearch, setShowSrarch] = useState(false)
  const closeSearch = useCallback(() => setShowSrarch(false), [])
  const openSearch = useCallback(() => setShowSrarch(true), [])
  return <>
    {showSearch && <TransitionGroup component={null}>
      <FadeTransition>
        <CarstaySMSearchDialog onClose={closeSearch} isStation={isStation} />
      </FadeTransition>
    </TransitionGroup>
    }
    <div
      onClick={openSearch}
      className={['bg-white c-pointer d-flex shadow px-3 align-items-center', styles.searchArea].join(' ')}
    >
      <Search className="fa mr-2"/>
      <div className={['font-size-14', styles.searchText].join(' ')}>
        <LocaleText ja="キャンピングカー・車中泊スポットを検索" en="Search for cars and to stay car spots." />
      </div>
    </div>
  </>
}

const defaultSettings = {
  arrows: false,
  dots: true,
  customPaging: () => <div className={styles.dot} />,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000
}

const CoverSM = ({isStation = false}: {isStation?: boolean}) => {
  const locale = useLocale()
  const [currentSlide, setCurrentSlide] = useState(0)
  const settings = {
    ...defaultSettings,
    beforeChange: (_: number, after: number) => { setCurrentSlide(after) }
  }
  const isMobileApp = !useIsSsr() && isNativeWebview()

  return <div className="w-100">
    <div className="w-100 position-relative">
      <div className="w-100 h-100 d-flex align-items-start overflow-hidden">
        <Slider {...settings} className={['w-100', styles.slider].join(' ')}>
          {locale === Locale.ja && <ResponsiveImg
            url={TopSP0}
            caption="TopSP0"
            className="w-100"
          />}
          <ResponsiveImg
            url={TopSP1}
            caption="TopSP1"
            className="w-100"
          />
          <ResponsiveImg
            url={TopSP2}
            caption="TopSP2"
            className="w-100"
          />
          {locale === Locale.ja && <ResponsiveImg
            url={TopSP3}
            caption="TopSP3"
            className="w-100"
          />}
          {locale === Locale.ja && <ResponsiveImg
            url={TopSP4}
            caption="TopSP4"
            className="w-100"
          />}
          {locale === Locale.ja && <ResponsiveImg
            url={TopSP5}
            caption="TopSP5"
            className="w-100"
          />}
        </Slider>
      </div>
      <div className={['position-absolute w-100 h-100', styles.top].join(' ')}>
        <div className="w-100 h-100 container">
          <div className={['position-relative w-100', styles.cover].join(' ')}>
            <SearchArea isStation={isStation}/>
            <h1 className={['text-white form-group ml-2', styles.title].join(' ')}>
              {
                currentSlide === 0 && locale === Locale.ja && <>
                  <LocaleText en="Would you like to create your own custom camping car" ja="SAny.リノベーションで自分だけの" />
                  <br/>
                  <LocaleText en="with SAny Renovation?" ja="キャンピングカーをつくりませんか" />
                </>
              }
              {
                ((currentSlide === 1 && locale === Locale.ja) || (currentSlide === 0 && locale === Locale.en)) && <>
                  <FormattedMessage id="user.camperShare"/>
                  <br/>
                  <FormattedMessage id="user.reserveCarstay"/>
                </>
              }
              {
                ((currentSlide === 2 && locale === Locale.ja) || (currentSlide === 1 && locale === Locale.en)) && <>
                  <LocaleText en="Enjoy Golden Week and summer vacation trip" ja="ゴールデンウィークも夏休みも！" />
                  <br/>
                  <LocaleText en="with long-term discounts!" ja="長期割引で、お得に旅を楽しもう！" />
                </>
              }
              {
                currentSlide === 3 && <>
                  <FormattedMessage id="user.withDog"/>
                  <br/>
                  <FormattedMessage id="user.takeTrip"/>
                </>
              }
              {
                currentSlide === 4 && <>
                  <LocaleText en="Enjoy an outdoor sauna" ja="好きな場所で、ととのえる。" />
                  <br/>
                  <LocaleText en="wherever you like!" ja="アウトドアサウナを楽しもう！" />
                </>
              }
              {
                currentSlide === 5 && <>
                  <FormattedMessage id="user.shareNotUsing"/>
                  <br/>
                  <FormattedMessage id="user.haveCamper"/>
                </>
              }
            </h1>

            <div className={['w-100 d-flex flex-column', styles.titleArea].join(' ')}>
              <div className="d-flex align-items-center justify-content-center">
                {
                  ((currentSlide === 1 && locale === Locale.ja) || (currentSlide === 0 && locale === Locale.en)) && !isMobileApp && <>
                    <div>
                      <a href="https://apps.apple.com/jp/app/id1531721547?l=ja"
                         target="_blank"
                         rel="noopener noreferrer"
                         className="mr-4"
                         title="アプリ/apple">
                        <AppStore className={styles.appleLink}/>
                      </a>
                    </div>
                    <div className={styles.androidLink}>
                      <a href="https://play.google.com/store/apps/details?id=jp.carstay.android&hl=ja"
                         target="_blank"
                         rel="noopener noreferrer"
                         className={['my-auto', styles.androidLink].join(' ')}
                         title="アプリ/android">
                        <ResponsiveImg
                          url={GooglePlay}
                          caption="GooglePlay"
                          dimension={GooglePlayDimension}
                        />
                      </a>
                    </div>
                  </>
                }
                {
                  (currentSlide === 0 || currentSlide === 2 || currentSlide === 3 || currentSlide === 4 || currentSlide === 5) && locale === Locale.ja && (
                    <Link
                      to={`/${locale}${currentSlide === 0
                      ? '/mobilab/?isSany=true'
                      : currentSlide === 2
                        ? '/car-list/?longRental=true'
                        : currentSlide === 3
                          ? '/vanlife-pets/'
                          : currentSlide === 4
                            ? '/vanlife-sauna/'
                            : `${UrlPrefix.holder}/`}`}
                      className={[
                        'btn btn-primary rounded-pill btn-lg w-100 font-weight-bold font-size-15',
                        styles.captionBtn
                      ].join(' ')}
                    >
                      {currentSlide === 2
                        ? <LocaleText en="Long-term discount lineup are here." ja="長期割引対象車種はこちら" />
                        : (currentSlide === 0 || currentSlide === 3)
                          ? <LocaleText en="Click here for more detail!" ja="詳しくはこちらから" />
                          : currentSlide === 4
                            ? <LocaleText en="Click here for VANLIFE SAUNA page." ja="VANLIFE SAUNA特設ページはこちら" />
                            : <FormattedMessage id="navbar.RentVan"/>}
                    </Link>
                  )
                }
                {locale === Locale.en && currentSlide === 1 && (
                  <Link to={`/${locale}/car-list/?longRental=true`}
                    className={[
                      'btn btn-primary rounded-pill btn-lg font-weight-bold font-size-15',
                      styles.captionBtn
                    ].join(' ')}
                  >
                    <LocaleText en="Long-term discount lineup are here." ja="長期割引対象車種はこちら" />
                  </Link>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
}
CoverSM.displayName = 'CoverSM'
export default CoverSM
